import { render, staticRenderFns } from "./Matured.vue?vue&type=template&id=5f11877a&scoped=true&"
import script from "./Matured.vue?vue&type=script&lang=js&"
export * from "./Matured.vue?vue&type=script&lang=js&"
import style0 from "./Matured.vue?vue&type=style&index=0&id=5f11877a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11877a",
  null
  
)

export default component.exports